<div [innerHTML]="data.html"></div>